// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";

// Components Imports

import TemplateSelection from "./TemplateSelection";
import UploadTemplate from "./UploadTemplate";

import { PATHS, EVENTS } from "../../constants";
import { AmplitudeUtils } from "../../utils";
import { customGAEvent } from "../../gtm/gtmutils";
import { GTM_CUSTOM_EVENTS, GTM_EVENT_PARAMS } from "../../gtm/gtmcustomevents";

// Actions Imports
import { DocumentTemplateActions } from "../../actions";
import { DOCUMENT_MODE } from "../../constants/document";
import { updateAutoTitleFlagMetaValues } from "../../actions/DocumentActions";
import LZLoader from "../../commonComponents/LZLoader";

// Destructuring
const {
  cloneTemplate,
  createNewTemplate,
  fetchAllDocumentTemplates,
  fetchDocumentTemplatesById,
} = DocumentTemplateActions;

// const QUOTE_TYPE_NAME = "Quote/Order Form";

class CreateTemplatePopup extends Component {
  constructor(props) {
    super(props);
    this.popupRef = React.createRef();

    this.state = {
      selectedCategoryID: null,
      loadingTemplates: false,
      showTemplateSelection: true,
      errMsg: "",
      isLoading: false,
      filterTemplatesByType: 0,
      templateName: "Untitled Template",
      loadMoreTemplates: false,
    };
  }

  componentDidMount() {
    this.props.fetchAllDocumentTemplates();
    // const quoteItem = this.props.documentTypes.find(
    //   item => item.name === QUOTE_TYPE_NAME,
    // );
    // if (quoteItem) {
    //   this._selectCategory(quoteItem.id);
    // } else {
    //   this._selectCategory(1);
    // }
    const modalScrollElement = document.getElementsByClassName(
      "styles_overlay__CLSq-",
    );
    if (modalScrollElement && modalScrollElement.length) {
      modalScrollElement[0].addEventListener("scroll", this._loadMoreTemplates);
    }
  }

  componentWillUnmount() {
    const modalScrollElement = document.getElementsByClassName(
      "styles_overlay__CLSq-",
    );
    if (modalScrollElement && modalScrollElement.length) {
      modalScrollElement[0].removeEventListener(
        "scroll",
        this._loadMoreTemplates,
      );
    }
  }

  _loadMoreTemplates = () => {
    const modalScrollElement = document.getElementsByClassName(
      "styles_overlay__CLSq-",
    );
    if (modalScrollElement && modalScrollElement.length) {
      if (
        modalScrollElement[0].scrollTop + modalScrollElement[0].clientHeight >=
        modalScrollElement[0].scrollHeight
      ) {
        const { hasMore, pageNum } = this.props;
        const { loadMoreTemplates } = this.state;
        if (hasMore && !loadMoreTemplates) {
          this.setState({ loadMoreTemplates: true });
          this.props
            .fetchAllDocumentTemplates(pageNum + 1, true)
            .then(() => {
              this.setState({ loadMoreTemplates: false });
            })
            .catch(() => {
              this.setState({ loadMoreTemplates: false });
            });
        }
      }
    }
  };

  _setTemplateSelectionView = () => {
    const { showTemplateSelection } = this.state;
    this.setState({
      showTemplateSelection: !showTemplateSelection,
    });
  };

  _handleNameChange = e => {
    this.setState({ templateName: e.target.value, errMsg: "" });
  };

  _setErrMsg = msg => {
    this.setState({ errMsg: msg });
  };

  _setDocUri = uri => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ docURI: uri });
  };

  // _selectCategory = categoryID => {
  //   this.setState({ loadingTemplates: true });
  //   this.setState({ filterTemplatesByType: categoryID });
  //   this.setState({ selectedCategoryID: categoryID });
  //   this.setState({ loadingTemplates: false });
  // };

  // _displayCategories = () => {
  //   const { documentTypes } = this.props;
  //   const { selectedCategoryID } = this.state;
  //   const category = documentTypes.map(item => {
  //     let className = "createdocumentpopup-categories-pills";
  //     if (selectedCategoryID === item.id) {
  //       className += " active";
  //     }
  //     let id = "document-category-default-id";
  //     if (item && item.name) {
  //       id = item.name.replace(/ +/g, "-").toLowerCase();
  //     }
  //     return (
  //       <span
  //         data-test="createdocpopup-doctype"
  //         className={className}
  //         key={item.id}
  //         id={id}
  //         onClick={() => this._selectCategory(item.id)}
  //         onKeyPress={() => null}
  //         role="button"
  //         tabIndex="0">
  //         {item.name}
  //       </span>
  //     );
  //   });
  //   return category;
  // };

  _createTemplate = (templateDetails, docDetails) => {
    this.setState({ isLoading: true });
    const { closePopUp } = this.props;
    createNewTemplate(templateDetails, docDetails).then(response => {
      const { Template } = response;
      if (!Template) {
        this.setState({
          errMsg: "Invalid content in the uploaded docx file",
          isLoading: false,
          // docDetails: undefined,
          // docName: undefined,
        });
      } else {
        const { id } = Template;
        closePopUp();
        this.props.history.push(`${PATHS.DOCSTEMPLATE_PATH}/${id}`);
        this.setState({ errMsg: "" });
        const params = {};
        params[GTM_EVENT_PARAMS.FROM_TEMPLATE] = this.state.templateName;
        customGAEvent(GTM_CUSTOM_EVENTS.TEMPLATE_CREATED, params);
        // amplitude call
        AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_CREATED, {
          ...Template,
          createdFrom: "blank/upload",
        });
      }
    });
  };

  _submitData = () => {
    const { templateName, docDetails, selectedCategoryID } = this.state;
    if (templateName === "") {
      this.setState({
        errMsg: "Please enter a name for the template.",
        // isLoading: false,
        // docDetails: undefined,
        // docName: undefined,
      });
      return;
    }
    const templateDetails = {
      type: {
        id: selectedCategoryID,
      },
      title: templateName,
      template_type: "form",
    };
    this._createTemplate(templateDetails, docDetails);
  };

  _setDocDetails = docDetails => {
    const { fileDetails, error } = docDetails;
    if (error) {
      this.setState({ errMsg: error, docDetails: null });
    } else {
      this.setState(
        {
          docDetails: fileDetails,
          errMsg: "",
        },
        () => this._submitData(),
      );
    }
  };

  _cloneTemplate = template => {
    if (this.state.templateName === "") {
      this.setState({
        errMsg: "Please enter a name for the template.",
        // isLoading: false,
        // docDetails: undefined,
        // docName: undefined,
      });
      return;
    }
    const params = {};
    params[GTM_EVENT_PARAMS.FROM_TEMPLATE] = template.title;
    customGAEvent(GTM_CUSTOM_EVENTS.TEMPLATE_CLONED, params);
    this.setState({ isLoading: true });
    const { closePopUp } = this.props;
    this.props
      .cloneTemplate(template.id, this.state.templateName)
      .then(async response => {
        const { Template } = response;
        const { id } = Template;

        await this.props.updateAutoTitleFlagMetaValues(
          DOCUMENT_MODE.TEMPLATE,
          id,
          "title_updated",
          false,
        );

        closePopUp();
        this.props.history.push(`${PATHS.DOCSTEMPLATE_PATH}/${id}`);
        this.setState({ errMsg: "" });
        // amplitude call
        AmplitudeUtils.amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_CREATED, {
          ...Template,
          createdFrom: "clone",
        });
      });
  };

  // _selectTemplate = item => {
  //   this.setState({ selectedTemplate: item });
  // };

  render() {
    // const { docSource, selectedCategoryID, sources } = this.state;

    const { closePopUp } = this.props;

    let errSpace = null;
    if (this.state.errMsg) {
      errSpace = (
        <div className="error-message-wrapper">
          <span className="error-message-icon">
            <FontAwesomeIcon icon={["far", "times-circle"]} />
          </span>
          {this.state.errMsg}
        </div>
      );
    }

    return (
      <div className="createdocumentpopup">
        <Modal
          open
          onClose={closePopUp}
          center
          styles={{ minWidth: "875px" }}
          closeOnOverlayClick={false}>
          {this.state.isLoading && (
            <LZLoader
              className="saving-document"
              label="Please wait while we create the template!"
              theme="dark"
              fullScreen
            />
          )}
          <div className="row">
            <div className="col-md-12">
              <div
                className="createdoc-title"
                data-test="createtemplatepopup-createdoc-title">
                Create new template
              </div>
              <div
                className="popup-form"
                data-test="createtemplatepopup-popup-form">
                {errSpace}
                {/* <div
                  className="revv-form-items"
                  data-test="createtemplatepopup-revv-form-items">
                  <span
                    className="revvform-label"
                    data-test="createtemplatepopup-revvform-label">
                    Template Name
                  </span>
                  <Input
                    id="templateName"
                    data-test="createtemplatepopup-templatename-inputfield"
                    name="templateName"
                    type="text"
                    placeholder="Enter template name"
                    onChange={value => this._handleNameChange(value)}
                    value={this.state.templateName}
                    autoFocus
                  />
                </div> */}
                {/* <div
                  className="choose-category-title"
                  data-test="createtemplatepopup-choose-category-title">
                  SELECT DOCUMENT TYPE
                </div>
                <div
                  className="category-column"
                  data-test="createtemplatepopup-category-column">
                  {this._displayCategories()}
                </div> */}

                {this.state.showTemplateSelection ? (
                  <div className="category-column choose-template-wrapper">
                    <div className="createdocpopup-category-title">
                      <div className="choose-category-title">
                        Clone from existing templates
                      </div>
                      {/* <div
                        id="create-upload-doc-btn"
                        className="get-back-to-templates"
                        data-test="createtemplatepopup-create-new-upload-template-button"
                        onClick={() => this._setTemplateSelectionView(false)}
                        onKeyPress={() => {}}
                        role="button"
                        tabIndex="0">
                        Create new/upload template
                      </div> */}
                    </div>
                    <TemplateSelection
                      templates={this.props.documentTemplates}
                      filterByType={this.state.filterTemplatesByType}
                      loading={this.state.loadingTemplates}
                      setView={this._setTemplateSelectionView}
                      createDoc={this._createDoc}
                      cloneTemplate={this._cloneTemplate}
                      // pbListLength={this.props.pbookOptions.length}
                    />
                  </div>
                ) : (
                  <UploadTemplate
                    templates={this.props.documentTemplates}
                    loading={this.state.loadingTemplates}
                    setView={this._setTemplateSelectionView}
                    // createDoc={this._createDoc}
                    setErrMsg={this._setErrMsg}
                    setDocUri={this._setDocUri}
                    setDoc={this._setDocDetails}
                    submitData={this._submitData}
                  />
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    documentTemplates,
    documentTemplatesInfo: { pageNum, hasMore },
  } = state.TemplateStore;
  // const { documentTypes } = state.DocumentStore;
  return {
    documentTemplates,
    //  documentTypes,
    hasMore,
    pageNum,
  };
};

const mapDispatchToProps = {
  cloneTemplate,
  fetchDocumentTemplatesById,
  fetchAllDocumentTemplates,
  updateAutoTitleFlagMetaValues,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CreateTemplatePopup));
